/**
 *  Widont
 *  ==============
 *
 *  Fixes all widows (typography).
 *
 *
 */

/*Fix all widows*/
new function () { var n = { auto: function (n) { return null != n ? t.auto = n : t.auto }, init: function () { return t.init() }, transform: function (n) { return t.widont(n) } }; $.jqwidont = n; var t = { auto: !0, init: i, widont: function (n) { return n.replace(t.regexp, "&#160;$1") }, regexp: new RegExp("[\\n\\r\\s]+([^\\n\\r\\s(?:&#160;)]+[\\n\\r\\s]*)$", "m") }; function i() { } $(document).ready(function () { t.auto }), $.fn.widont = function () { return $(this).each(function () { var n = $(this); n.html(t.widont(n.html())) }) } };

function fixwidows() {
    //wait a bit and fix all widows
    $('main p, main h1, main h2, main h3').not('.ignore-widow').widont();
}

window.addEventListener('DOMContentLoaded', fixwidows);

/**
 * LICENSE
 *
 * jQWidon't v0.1 - Suppress typographic widows
 *   * http://davecardwell.co.uk/javascript/jquery/plugins/jquery-widont/0.1/
 *
 * Dave Cardwell <http://davecardwell.co.uk/>
 *
 * Built on the shoulders of giants:
 *   * John Resig <http://jquery.com/>
 *   * Shaun Inman <http://www.shauninman.com/plete/2006/08/...
 *                                             ...widont-wordpress-plugin.php>
 *
 *
 * Copyright (c) 2006 Dave Cardwell, dual licensed under the MIT and GPL
 * licenses:
 *   * http://www.opensource.org/licenses/mit-license.php
 *   * http://www.gnu.org/licenses/gpl.txt
 */